import { Children } from 'react';
import { Row, Col } from 'antd';
import type { ReactNode } from 'react';

export interface KpiRowBreakpoints {
  xs?: number;
  sm?: number;
  lg?: number;
  xl?: number;
}

interface KpiRowProps {
  children: ReactNode;
  /** Span de ant-col por breakpoint. Default: xs=24 sm=12 lg=6 (4 por fila). */
  breakpoints?: KpiRowBreakpoints;
}

export function KpiRow({ children, breakpoints = {} }: KpiRowProps) {
  // Children.toArray aplana arrays anidados (ej. un card + un .map()) y
  // fragments: sin esto un `<KpiCard />{lista.map(...)}` genera 2 columnas
  // con el resto de las cards apiladas dentro de la segunda.
  const items = Children.toArray(children);
  if (items.length === 0) {
    return null;
  }
  const { xs = 24, sm = 12, lg = 6, xl } = breakpoints;
  return (
    <Row gutter={[20, 20]}>
      {items.map((child, idx) => (
        <Col xs={xs} sm={sm} lg={lg} xl={xl} key={idx}>
          {child}
        </Col>
      ))}
    </Row>
  );
}
